<!--
* UI Name: MQ
* Modify Date: 2021/03/03
-->
<template>
  <v-card flat>
    <v-card-text>
      <v-form ref="form" lazy-validation class="px-4">
        <!-- First Row -->
        <v-row>
          <v-col cols="12" md="4" class="mt-6">
            <font class="text-base font-bold leading-snug textcolor5--text">
              {{ $t('lbl.communications.mq') }}
            </font>
            <v-text-field
              v-model="formData.name"
              :rules="
                formData.name && formData.name.length > 50
                  ? ['Max 50 characters']
                  : [validationUtils.required]
              "
              :error-messages="formError.name.message"
              placeholder="Enter the name"
              ref="name"
              :autofocus="true"
              solo
              :disabled="!$auth.manage"
              class="mt-5"
            ></v-text-field>
          </v-col>
          <!-- // 2021.8.30 203728 SPKA-201 remove partner from communication -->
          <!-- <v-col cols="12" md="4">
            <v-select
              v-model="formData.partner"
              :items="partners"
              :placeholder="$t('lbl.common.conditionSearch.selectPartner')"
              solo
              :menu-props="{ offsetY: true, }"
              :disabled="!$auth.manage"
            ></v-select>
          </v-col> -->
        </v-row>
        <!-- 2 Row 54px-->
        <v-row>
          <v-col cols="12" md="4" class="px-4">
            <v-label><v-icon x-small class="mr-1">fa fa-asterisk</v-icon>MQ Type</v-label>
            <v-select
              v-model="formData.type"
              :rules="[validationUtils.required]"
              :items="mqType"
              solo
              :menu-props="{ offsetY: true }"
              :disabled="!$auth.manage"
            ></v-select>
          </v-col>
          <v-col cols="12" md="8" class="px-4">
            <v-row>
              <v-col cols="12" md="8" class="pr-0">
                <v-label><v-icon x-small class="mr-1">fa fa-asterisk</v-icon>Host</v-label>
                <v-text-field
                  v-model="formData.host"
                  :rules="[
                    validationUtils.required,
                    validationUtils.min(8),
                    validationUtils.max(100),
                  ]"
                  solo
                  :disabled="!$auth.manage"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-label><v-icon x-small class="mr-1">fa fa-asterisk</v-icon>Port</v-label>
                <v-text-field
                  v-model="formData.port"
                  type="number"
                  :rules="[validationUtils.required, validationUtils.max(5)]"
                  solo
                  :disabled="!$auth.manage"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row><v-col cols="12" md="12" class="h-2"></v-col></v-row>
        <!--3 Row 40px-->
        <v-row>
          <v-col cols="12" md="6" class="px-4">
            <v-label><v-icon x-small class="mr-1">fa fa-asterisk</v-icon>Queue Name</v-label>
            <v-text-field
              v-model="formData.comm_mq_nm"
              :rules="[validationUtils.required, validationUtils.max(50)]"
              solo
              :disabled="!$auth.manage"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6" class="px-4">
            <v-label>Queue Manager</v-label>
            <v-text-field
              v-model="formData.comm_mq_mgr"
              :rules="
                formData.comm_mq_mgr && formData.comm_mq_mgr.length > 50
                  ? ['Max 50 characters']
                  : []
              "
              solo
              :disabled="!$auth.manage"
            ></v-text-field>
          </v-col>
        </v-row>
        <!-- // 05/24/2021 203737 SPKA-115 issue 63 Add interval type in communication component -->
        <v-row>
          <v-col cols="12" md="6" class="px-4">
            <v-row>
              <v-col cols="12" md="6" class="pr-0">
                <v-label
                  ><v-icon x-small class="mr-1">fa fa-asterisk</v-icon
                  >{{ $t('lbl.communications.exeInterval') }}</v-label
                >
                <v-text-field
                  v-model="formData.interval"
                  type="number"
                  :rules="[validationUtils.required, validateInterval(intervalDefault)]"
                  solo
                  :disabled="!$auth.manage"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  v-model="intervalDefault"
                  :items="intervals"
                  solo
                  :menu-props="{ offsetY: true }"
                  :disabled="!$auth.manage"
                  return-object
                  class="select-interval"
                ></v-select>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="3" class="pr-0">
            <v-label>{{ $t('lbl.communications.maxRetryAttempts') }}</v-label>
            <v-text-field
              v-model="formData.maxRetry"
              type="number"
              solo
              :disabled="!$auth.manage"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { getEditData } from '@/vue-caas/utils/process';

export default {
  props: {
    item: {
      type: Object,
    },
  },

  data() {
    return {
      mqType: [
        { text: 'IBM MQ', value: 'IBM_MQ' },
        { text: 'Active MQ', value: 'ACTIVE_MQ' },
      ],
      formData: {},
      loadFormData: {},
      formError: {
        name: {
          message: '',
        },
      },
      intervals: [
        { text: this.$t('msg.communications.seconds'), value: 'SS' },
        { text: this.$t('msg.communications.minutes'), value: 'MM' },
        { text: this.$t('msg.communications.hours'), value: 'HH' },
      ],
      intervalDefault: {
        text: this.$t('msg.communications.minutes'),
        value: 'MM',
      },
    };
  },

  created() {
    // 05/24/2021 203737 SPKA-115 issue 63 Add interval type in communication component
    this.formData = Object.assign({}, this.getInitData(), this.item);
    if (!this.formData.interval) {
      this.formData.interval = '30';
    }
    this.loadFormData = Object.assign({}, this.getInitData(), this.item);
    // 2021.8.30 203728 SPKA-201 remove partner from communication
    // this.partners = this.prnrList;
    if (this.item.intervalType) {
      this.intervalDefault = this.intervals.filter(
        (item) => item.value === this.item.intervalType,
      )[0];
    }
  },

  watch: {
    item() {
      this.resetFormData();
      this.setFocus();
    },
  },

  methods: {
    async save() {
      this.formData.path =
        this.formData.type == 'IBM_MQ'
          ? 'queue://' + this.formData.comm_mq_mgr + '/' + this.formData.comm_mq_nm
          : 'queue://' + this.formData.comm_mq_nm;

      let editedData = getEditData(this.formData, this.loadFormData);
      editedData.id = this.formData.id;
      if (editedData.name === undefined) {
        editedData.name = this.formData.name;
      }
      // 05/24/2021 203737 SPKA-115 issue 63 Add interval type in communication component
      if (this.intervalDefault.value) {
        this.formData.intervalType = this.intervalDefault.value;
        editedData.intervalType = this.intervalDefault.value;
      }
      editedData.protocol = this.formData.type;
      if (this.formData.action == 'edit') {
        await this.$store.dispatch('editComm', this.formData);
        await this.sendActivate(this.formData.id, 'COM', editedData);
      } else {
        // this.formData.type = 'IBM_MQ';
        await this.$store.dispatch('insertComm', this.formData);
      }
      this.resetFormData();
    },
    async sendActivate(comId, comTp, info) {
      const params = {
        comId: comId,
        comTp: comTp,
        info: info,
      };
      await this.$store.dispatch('updateProcessInfo', params);
    },

    getInitData() {
      return {
        name: '',
        partner: '',
        direction: '',
        host: '',
        security: '',
        port: '',
        userid: '',
        password: '',
        path: '',
        interval: '30',
        type: '',
        comm_mq_nm: '',
        comm_mq_mgr: '',
      };
    },
    resetFormData() {
      if (this.item.type == 'IBM_MQ' || this.item.type == 'ACTIVE_MQ') {
        this.formData = Object.assign({}, this.getInitData(), this.item);
        this.$refs.form.resetValidation();
      }
    },
    setFieldValidation(name, message) {
      this.formError[name] = {
        message,
      };
    },
    setFocus() {
      setTimeout(() => {
        this.$refs.name.focus();
      }, 300);
    },
    // 05/24/2021 203737 SPKA-115 issue 63 Add interval type in communication component
    validateInterval(item) {
      let interval = this.formData.interval;
      if (interval) {
        switch (item.value) {
          case 'SS': {
            // 05/31/2021 203737 SPKA-127 issue 76 Change minimum interval value for "Seconds" from 30 to 10. (validation allow 10~59 seconds)
            if (interval < 10 || interval > 59) {
              return this.$t('msg.communications.validateInterval', ['10', '59', 'seconds']);
            }
            break;
          }
          case 'HH': {
            if (interval < 1 || interval > 24) {
              return this.$t('msg.communications.validateInterval', ['1', '24', 'hours']);
            }
            break;
          }
          default: {
            if (interval < 1 || interval > 59) {
              return this.$t('msg.communications.validateInterval', ['1', '59', 'minutes']);
            }
          }
        }
      }
      return true;
    },
  },
};
</script>
